// Login
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const EXPIRED_TOKEN = 'EXPIRED_TOKEN';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const AUTH_SET_LOADING = 'AUTH_SET_LOADING';
// Registration
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const REGISTER_SET_LOADING ='REGISTER_SET_LOADING'
export const SET_AUTH_LOADING ='SET_AUTH_LOADING'

// // Switch User
// export const SWITCH_USER_SUCCESS = 'SWITCH_USER_SUCCESS';
// export const SWITCH_USER_FAIL = 'SWITCH_USER_FAIL';
// export const SWITCH_USER_LOADED = 'SWITCH_USER_LOADED';
// export const SWITCH_USER_LOGOUT_SUCCESS = 'SWITCH_USER_LOGOUT_SUCCESS';
// Alerts
export const GET_SUCCESS = 'GET_SUCCESS';
export const GET_INFO = 'GET_INFO';
export const GET_ERRORS = 'GET_ERRORS';
// Loading
export const SET_LOADING = 'SET_LOADING';

// uplad File
export const GET_FILE_LIST = 'GET_FILE_LIST'
export const UPLOAD_FILE = 'UPLOAD_FILE'
export const IMPORT_FILE_DATA = 'IMPORT_FILE_DATA'
export const IMPORT_FILE_SET_LOADING = 'IMPORT_FILE_SET_LOADING'
export const UPLOAD_FILE_SET_LOADING = 'UPLOAD_FILE_SET_LOADING'
export const UPLOAD_FILE_ERROR = 'UPLOAD_FILE_ERROR'
export const IMPORT_FILE_ERROR = 'IMPORT_FILE_ERROR'
export const DELETE_FILE = 'DELETE_FILE'

export const GET_FOUR_FIFTH_FILES = 'GET_FOUR_FIFTH_FILES'
export const GET_FOUR_FIFTH_FILES_ERROR = 'GET_FOUR_FIFTH_FILES_ERROR'
export const POST_FOUR_FIFTH_FILE = 'POST_FOUR_FIFTH_FILE'
export const POST_FOUR_FIFTH_FILE_ERROR = 'POST_FOUR_FIFTH_FILE_ERROR'

export const IMPORT_FOUR_FIFTH_FILE = 'IMPORT_FOUR_FIFTH_FILE'
export const IMPORT_FOUR_FIFTH_FILE_ERROR = 'IMPORT_FOUR_FIFTH_FILE_ERROR'
export const CLEAR_ERROR = 'CLEAR_ERROR'

// checkerCreator
export const CHECK_FILE = 'CHECK_FILE' 
export const CREATE_FIVES_FOURS = 'CREATE_FIVES_FOURS' 
export const CHECK_FOURS = 'CHECK_FOURS' 
export const CREATE_FOURS = 'CREATE_FOURS' 
export const CHECK_FIVE = 'CHECK_FIVE'
export const CREATE_FIVE = 'CREATE_FIVE'
export const CHECKER_SET_LOADING = 'CHECKER_SET_LOADING'
export const CHECKER_ERROR = 'CHECKER_ERROR'

// Edit OPK
export const OPK_SET_LOADING = 'OPK_SET_LOADING'
export const GET_OPK = 'GET_OPK'
export const PUT_OPK = 'PUT_OPK'
export const DELETE_OPK = 'DELETE_OPK'
export const GET_GROUP_CODE_5 = 'GET_GROUP_CODE_5'
export const OPK_ERROR = 'OPK_ERROR'

//Calculations settings
export const GET_CALC_SETTINGS = 'GET_CALC_SETTINGS'
export const PUT_CALC_SETTINGS = 'PUT_CALC_SETTINGS'
export const SET_LOADING_CALC_SETTINGS = 'SET_LOADING_CALC_SETTINGS'
export const CALC_ERROR = 'CALC_ERROR'

// Edit Four
export const FOUR_SET_LOADING = 'FOUR_SET_LOADING'
export const GET_FOUR = 'GET_FOUR'
export const PUT_FOUR = 'PUT_FOUR'
export const GET_GROUP_CODE_4 = 'GET_GROUP_CODE_4'
export const FOUR_ERROR = 'FOUR_ERROR'

//report loading
export const SET_REPORT_LOADING = 'SET_REPORT_LOADING'
export const SET_NESTED_LOADING = 'SET_NESTED_LOADING'

//raport 0 prawdziwy
export const  GET_REPORT0_REAL = 'GET_REPORT0_REAL'
export const GET_REPORT0_FAIL_REAL = 'GET_REPORT0_FAIL_REAL'
export const CLEAR_STATE_REPORT0_REAL = 'CLEAR_STATE_REPORT0_REAL'
//raport 0 - narazie myopk
export const  GET_REPORT0 = 'GET_REPORT0'
export const GET_REPORT_FAIL0 = 'GET_REPORT_FAIL0'
export const CLEAR_STATE_REPORT0 = 'CLEAR_STATE_REPORT0'
//report 1
export const GET_REPORT1 = "GET_REPORT1"
export const GET_REPORT_FAIL1 = 'GET_REPORT_FAIL1'
export const CLEAR_STATE_REPORT1 = 'CLEAR_STATE_REPORT1'
//get new row 1
export const GET_CODE_1 = 'GET_CODE_1'
export const GET_FAIL_CODE1 = 'GET_FAIL_CODE1'
export const CLEAR_CODE1 = 'CLEAR_CODE1'
//report 2
export const GET_REPORT2 = "GET_REPORT2"
export const GET_REPORT_FAIL2 = 'GET_REPORT_FAIL2'
export const CLEAR_STATE_REPORT2 = 'CLEAR_STATE_REPORT2'
//raport 31
export const GET_REPORT31 = "GET_REPORT31"
export const GET_REPORT_FAIL31 = 'GET_REPORT_FAIL31'
export const CLEAR_STATE_REPORT31 = 'CLEAR_STATE_REPORT31'
//get new row 31
export const GET_CODE_31 = 'GET_CODE_31'
export const GET_FAIL_CODE31 = 'GET_FAIL_CODE31'
export const CLEAR_CODE31 = 'CLEAR_CODE31'
//raport 32
export const GET_REPORT32 = "GET_REPORT32"
export const GET_REPORT_FAIL32 = 'GET_REPORT_FAIL32'
export const CLEAR_STATE_REPORT32 = 'CLEAR_STATE_REPORT32'
//get new row 32
export const GET_CODE_32 = 'GET_CODE_32'
export const GET_FAIL_CODE32 = 'GET_FAIL_CODE32'
export const CLEAR_CODE32 = 'CLEAR_CODE32'
//report 4
export const GET_REPORT4 = 'GET_REPORT4'
export const GET_REPORT_FAIL4 = 'GET_REPORT_FAIL4'
export const CLEAR_STATE_REPORT4 = 'CLEAR_STATE_REPORT4'
//get new row 4
export const GET_CODE4 = 'GET_CODE4'
export const GET_FAIL_CODE4 = 'GET_FAIL_CODE4'
export const CLEAR_CODE4 = 'CLEAR_CODE4'
export const GET_FAIL_CODE4_NESTED = 'GET_FAIL_CODE4_NESTED'
export const GET_CODE4_NESTED = 'GET_CODE4_NESTED'

//report 5
export const GET_REPORT5 = 'GET_REPORT5'
export const GET_REPORT_FAIL5 = 'GET_REPORT_FAIL5'
export const CLEAR_STATE_REPORT5 = 'CLEAR_STATE_REPORT5'

//get row 5
export const GET_CODE_5 = 'GET_CODE_5'
export const GET_FAIL_CODE5 = 'GET_FAIL_CODE5'
export const CLEAR_CODE5 = 'CLEAR_CODE5'

//Raport 6
export const  GET_REPORT6 = 'GET_REPORT6'
export const GET_REPORT_FAIL6 = 'GET_REPORT_FAIL6'
export const CLEAR_STATE_REPORT6 = 'CLEAR_STATE_REPORT6'
//getrow6
export const GET_CODE_6 = 'GET_CODE_6'
export const GET_FAIL_CODE6 = 'GET_FAIL_CODE6'
export const CLEAR_CODE6 = 'CLEAR_CODE6'
export const GET_CODE_6_NESTED = 'GET_CODE_6_NESTED'
export const GET_FAIL_CODE6_NESTED = 'GET_FAIL_CODE6_NESTED'
//raport 7
export const  GET_REPORT7 = 'GET_REPORT7'
export const GET_REPORT_FAIL7 = 'GET_REPORT_FAIL7'
export const CLEAR_STATE_REPORT7 = 'CLEAR_STATE_REPORT7'

//raport 8
export const  GET_REPORT8 = 'GET_REPORT8'
export const GET_REPORT_FAIL8 = 'GET_REPORT_FAIL8'
export const CLEAR_STATE_REPORT8 = 'CLEAR_STATE_REPORT8'
export const  GET_REPORT82 = 'GET_REPORT82'
export const GET_REPORT_FAIL82 = 'GET_REPORT_FAIL82'
export const CLEAR_STATE_REPORT82 = 'CLEAR_STATE_REPORT82'

//report 9
export const  GET_REPORT9 = 'GET_REPORT9'
export const GET_REPORT_FAIL9 = 'GET_REPORT_FAIL9'
export const CLEAR_STATE_REPORT9 = 'CLEAR_STATE_REPORT9'

//raport 10
export const  GET_REPORT10 = 'GET_REPORT10'
export const GET_REPORT_FAIL10 = 'GET_REPORT_FAIL10'
export const CLEAR_STATE_REPORT10 = 'CLEAR_STATE_REPORT10'

//companies all
export const  GET_COMPANIES = 'GET_COMPANIES'
export const SET_COMPANIES_LOADING ='SET_COMPANIES_LOADING'
export const GET_COMPANIES_FAIL = 'GET_COMPANIES_FAIL'
export const CLEAR_STATE_COMAPANIES = 'CLEAR_STATE_COMAPANIES'


//post company
export const  POST_COMPANY = 'POST_COMPANY'
export const REGISTER_COMPANY_SET_LOADING = 'REGISTER_COMPANY_SET_LOADING'
export const REGISTER_COMPANY_SUCCESS = 'REGISTER_COMPANY_SUCCESS'
export const REGISTER_COMPANY_FAIL = 'REGISTER_COMPANY_FAIL'



///my company
export const GET__MY_COMPANY = 'GET__MY_COMPANY'
export const SET_MY_COMPANY_LOADING ='SET_MY_COMPANY_LOADING'
export const GET_MY_COMPANY_FAIL = 'GET_MY_COMPANY_FAIL'
export const CLEAR_STATE_MY_COMAPANY = 'CLEAR_STATE_MY_COMAPANY'
//get all requests
export const GET_ALL_REQUESTS = 'GET_ALL_REQUESTS'
export const SET_ALL_REQUESTS_LOADING ='SET_ALL_REQUESTS_LOADING'
export const GET_ALL_REQUESTS_FAIL = 'GET_ALL_REQUESTS_FAIL'
export const CLEAR_STATE_ALL_REQUESTS = 'CLEAR_STATE_ALL_REQUESTS'
///GET company request
export const GET_COMPANY_REQUESTS = 'GET_COMPANY_REQUESTS'
export const SET_COMPANY_REQUESTS_LOADING ='SET_COMPANY_REQUESTS_LOADING'
export const GET_COMPANY_REQUESTS_FAIL = 'GET_COMPANY_REQUESTS_FAIL'
export const CLEAR_STATE_COMPANY_REQUESTS = 'CLEAR_STATE_COMPANY_REQUESTS'
// anulowanie request
export const POST_CANACEL_REQUEST = 'POST_CANACEL_REQUEST'
export const LOADING_CANACEL_REQUEST = 'LOADING_CANACEL_REQUEST'
export const CANACEL_REQUEST_FAIL = 'CANACEL_REQUEST_FAIL'
// request to join company
export const POST_REQUEST_COMPANY = 'POST_REQUEST_COMPANY'
export const LOADING_REQUEST_COMPANY = 'LOADING_REQUEST_COMPANY'
export const REQUEST_COMPANY_FAIL = 'REQUEST_COMPANY_FAIL'
//reject prośby
export const POST_REJECT_REQUEST = 'POST_REJECT_REQUEST'
export const LOADING_REJECT_REQUEST = 'LOADING_REJECT_REQUEST'
export const REJECT_REQUEST_FAIL = 'REJECT_REQUEST_FAIL'
//accept prośby
export const POST_ACCEPT_REQUEST = 'POST_ACCEPT_REQUEST'
export const LOADING_ACCEPT_REQUEST = 'LOADING_ACCEPT_REQUEST'
export const POST_ACCEPT_FAIL = 'POST_ACCEPT_FAIL'
//odrzucenie prośby

//opk selects numbers
export const GET_OPK_NUMBERS = 'GET_OPK_NUMBERS'
export const SET_OPK_NUMBERS_LOADING ='SET_OPK_NUMBERS_LOADING'
export const GET_OPK_NUMBERS_FAIL = 'GET_OPK_NUMBERS_FAIL'
export const CLEAR_STATE_OPK_NUMBERS = 'CLEAR_STATE_OPK_NUMBERS'

//opk selects numbers7
export const GET_OPK_NUMBERS7 = 'GET_OPK_NUMBERS7'
export const SET_OPK_NUMBERS7_LOADING ='SET_OPK_NUMBERS7_LOADING'
export const GET_OPK_NUMBERS7_FAIL = 'GET_OPK_NUMBERS7_FAIL'
export const CLEAR_STATE_OPK_NUMBERS7 = 'CLEAR_STATE_OPK_NUMBERS7'

//opk select names

export const GET_OPK_NAMES = 'GET_OPK_NAMES'
export const SET_OPK_NAMES_LOADING ='SET_OPK_NAMES_LOADING'
export const GET_OPK_NAMES_FAIL = 'GET_OPK_NAMES_FAIL'
export const CLEAR_STATE_OPK_NAMES = 'CLEAR_STATE_OPK_NAMES'
//opk proceduralny
export const GET_OPK_NUMBERS_PROC = 'GET_OPK_NUMBERS_PROC'
export const SET_OPK_NUMBERS_LOADING_PROC ='SET_OPK_NUMBERS_LOADING_PROC'
export const GET_OPK_NUMBERS_FAIL_PROC = 'GET_OPK_NUMBERS_FAIL_PROC'
export const CLEAR_STATE_OPK_NUMBERS_PROC = 'CLEAR_STATE_OPK_NUMBERS_PROC'
//opk names proceduralny

export const GET_OPK_NAMES_PROC = 'GET_OPK_NAMES_PROC'
export const SET_OPK_NAMES_LOADING_PROC ='SET_OPK_NAMES_LOADING_PROC'
export const GET_OPK_NAMES_FAIL_PROC = 'GET_OPK_NAMES_FAIL_PROC'
export const CLEAR_STATE_OPK_NAMES_PROC = 'CLEAR_STATE_OPK_NAMES_PROC'

//opk name + number

export const GET_OPK_FULL = 'GET_OPK_FULL'
export const SET_OPK_FULL_LOADING ='SET_OPK_FULL_LOADING'
export const GET_OPK_FULL_FAIL = 'GET_OPK_FULL_FAIL'
export const CLEAR_STATE_OPK_FULL = 'CLEAR_STATE_OPK_FULL'

//pulpit manegerski
//wykres głowny 
export const GET_MAIN_TABLE_PULPIT = 'GET_MAIN_TABLE_PULPIT'
export const SET_MAIN_TABLE_LOADING = 'SET_MAIN_TABLE_LOADING'
export const GET_MAIN_TABLE_PULPIT_FAIL = 'GET_MAIN_TABLE_PULPIT_FAIL'
export const CLEAR_MAIN_TABLE_PULPIT = 'CLEAR_MAIN_TABLE_PULPIT'

//kody dla main table
export const GET_CODE_MAIN_TABLE= 'GET_CODE_MAIN_TABLE'
export const GET_LOADING_CODE_MAIN_TABLE = 'GET_LOADING_CODE_MAIN_TABLE'
export const GET_FAIL_CODE_MAIN_TABLE = 'GET_FAIL_CODE_MAIN_TABLE'
export const CLEAR_CODE_MAIN_TABLE = 'CLEAR_CODE_MAIN_TABLE'

//reszta tabel wspólnie 

export const GET_FINANCE_TABLE_PULPIT = 'GET_FINANCE_TABLE_PULPIT'
export const SET_FINANCE_TABLE_LOADING = 'SET_FINANCE_TABLE_LOADING'
export const GET_FINANCE_TABLE_PULPIT_FAIL = 'GET_FINANCE_TABLE_PULPIT_FAIL'
export const CLEAR_FINANCE_TABLE_PULPIT = 'CLEAR_FINANCE_TABLE_PULPIT'

//get row dla bezpośrednich

export const GET_INDIRECT_COST_ROW = 'GET_INDIRECT_COST_ROW'
export const SET_INDIRECT_COST_ROW_LOADING = 'SET_INDIRECT_COST_ROW_LOADING'
export const GET_INDIRECT_COST_ROW_FAIL = 'GET_INDIRECT_COST_ROW_FAIL'
export const CLEAR_INDIRECT_COST_ROW = 'CLEAR_INDIRECT_COST_ROW'

//moduł wyceny procedur

///materiały

export const GET_MATERIALS = 'GET_MATERIALS'
export const SET_MATERIALS_LOADING = 'SET_MATERIALS_LOADING'
export const GET_MATERIALS_FAIL = 'GET_MATERIALS_FAIL'
export const CLEAR_MATERIALS = 'CLEAR_MATERIALS'

//załaduj materiały z pliku
export const GET_MATERIAL_TEMPLATE = 'GET_MATERIAL_TEMPLATE';
export const POST_MATERIAL_FILE = 'POST_MATERIAL_FILE';
export const POST_MATERIAL_FILE_LOADING = 'POST_MATERIAL_FILE_LOADING';
export const POST_MATERIAL_FILE_FAIL = 'POST_MATERIAL_FILE_FAIL';
export const GET_MATERIAL_FILES = 'GET_MATERIAL_FILES';
export const GET_MATERIAL_FILES_FAIL = 'GET_MATERIAL_FILES_FAIL';

//załaduj personel z pliku
export const GET_PERSONEL_TEMPLATE = 'GET_PERSONEL_TEMPLATE';
export const POST_PERSONEL_FILE = 'POST_PERSONEL_FILE';
export const POST_PERSONEL_FILE_LOADING = 'POST_PERSONEL_FILE_LOADING';
export const POST_PERSONEL_FILE_FAIL = 'POST_PERSONEL_FILE_FAIL';
export const GET_PERSONEL_FILES = 'GET_PERSONEL_FILES';
export const GET_PERSONEL_FILES_FAIL = 'GET_PERSONEL_FILES_FAIL';
//ZAŁDUJ procedury z pliku
export const GET_PROCEDURY_TEMPLATE = 'GET_PROCEDURY_TEMPLATE';
export const POST_PROCEDURY_FILE = 'POST_PROCEDURY_FILE';
export const POST_PROCEDURY_FILE_LOADING = 'POST_PROCEDURY_FILE_LOADING';
export const POST_PROCEDURY_FILE_FAIL = 'POST_PROCEDURY_FILE_FAIL';
export const GET_PROCEDURY_FILES = 'GET_PROCEDURY_FILES';
export const GET_PROCEDURY_FILES_FAIL = 'GET_PROCEDURY_FILES_FAIL';

//wysyłanie materiały

export const POST_MATERIAL = 'POST_MATERIAL'
export const POST_MATERIAL_SET_LOADING = 'POST_MATERIAL_SET_LOADING'
export const POST_MATERIAL_SUCCESS = 'POST_MATERIAL_SUCCESS'
export const POST_MATERIAL_FAIL = 'POST_MATERIAL_FAIL'
export const CLEAR_ERROR_MATERIALS = 'CLEAR_ERROR_MATERIALS'
//edycja materiały
export const EDIT_MATERIAL_SET_LOADING = 'EDIT_MATERIAL_SET_LOADING'
export const EDIT_MATERIAL_SUCCESS = 'EDIT_MATERIAL_SUCCESS'
export const EDIT_MATERIAL_FAIL = 'EDIT_MATERIAL_FAIL'
export const DELETE_MATERIAL_SUCCESS = 'DELETE_MATERIAL_SUCCESS'
export const DELETE__MATERIAL_FAIL = 'DELETE__MATERIAL_FAIL'

//zasoby osobowe
export const GET_PERSONEL = 'GET_PERSONEL'
export const SET_PERSONEL_LOADING = 'SET_PERSONEL_LOADING'
export const GET_PERSONEL_FAIL = 'GET_PERSONEL_FAIL'
export const CLEAR_PERSONEL = 'CLEAR_PERSONEL'
export const EDIT_PERSONEL_SET_LOADING = 'EDIT_PERSONEL_SET_LOADING'
export const EDIT_PERSONEL_SUCCESS = 'EDIT_PERSONEL_SUCCESS'
export const EDIT_PERSONEL_FAIL = 'EDIT_PERSONEL_FAIL'
export const DELETE_PERSONEL_SUCCESS = 'DELETE_PERSONEL_SUCCESS'
export const DELETE_PERSONEL_FAIL = 'DELETE_PERSONEL_FAIL'

//wysyłanie personel

export const POST_PERSONEL = 'POST_PERSONEL'
export const POST_PERSONEL_SET_LOADING = 'POST_PERSONEL_SET_LOADING'
export const POST_PERSONEL_SUCCESS = 'POST_PERSONEL_SUCCESS'
export const POST_PERSONEL_FAIL = 'POST_PERSONEL_FAIL'

// select do opk dla staff
export const GET_NUMER_OPK_PROC = 'GET_NUMER_OPK_PROC'
export const SET_NUMER_OPK_PROC_LOADING = 'SET_NUMER_OPK_PROC_LOADING'
export const GET_NUMER_OPK_PROC_FAIL = 'GET_NUMER_OPK_PROC_FAIL'
export const CLEAR_NUMER_OPK_PROC= 'CLEAR_NUMER_OPK_PROC'

//select category personel

export const GET_CATEGORY_PERSONEL = 'GET_CATEGORY_PERSONEL'
export const SET_CATEGORY_PERSONEL_LOADING = 'SET_CATEGORY_PERSONEL_LOADING'
export const GET_CATEGORY_PERSONEL_FAIL = 'GET_CATEGORY_PERSONEL_FAIL'
export const CLEAR_CATEGORY_PERSONEL= 'CLEAR_CATEGORY_PERSONEL'

//definicja procedury
//get procedure
export const GET_PROCEDURE = 'GET_PROCEDURE'
export const SET_PROCEDURE_LOADING = 'SET_PROCEDURE_LOADING'
export const GET_PROCEDURE_FAIL = 'GET_PROCEDURE_FAIL'
export const CLEAR_PROCEDURE = 'CLEAR_PROCEDURE'
//del procedura
export const DELETE_PROCEDURA_FAIL ='DELETE_PROCEDURA_FAIL'
export const DELETE_PROCEDURA_SUCCESS = 'DELETE_PROCEDURA_SUCCESS'
//opk 507
export const GET_NUMER_OPK_PROC507 = 'GET_NUMER_OPK_PROC507'
export const SET_NUMER_OPK_PROC_LOADING507 = 'SET_NUMER_OPK_PROC_LOADING507'
export const GET_NUMER_OPK_PROC_FAIL507 = 'GET_NUMER_OPK_PROC_FAIL507'
export const CLEAR_NUMER_OPK_PROC507= 'CLEAR_NUMER_OPK_PROC507'

//post procedure

export const POST_PROCEDURA = 'POST_PROCEDURA'
export const POST_PROCEDURA_SET_LOADING = 'POST_PROCEDURA_SET_LOADING'
export const POST_PROCEDURA_SUCCESS = 'POST_PROCEDURA_SUCCESS'
export const POST_PROCEDURA_FAIL = 'POST_PROCEDURA_FAIL'
///edit procedure
export const EDIT_PROCEDURA_SET_LOADING = 'EDIT_PROCEDURA_SET_LOADING'
export const EDIT_PROCEDURA_FAIL = 'EDIT_PROCEDURA_FAIL'
export const EDIT_PROCEDURA_SUCCESS = 'EDIT_PROCEDURA_SUCCESS'

//icd9 słoWnik
export const GET_ICD9 = 'GET_ICD9'
export const SET_ICD9_LOADING = 'SET_ICD9_LOADING'
export const GET_ICD9_FAIL = 'GET_ICD9_FAIL'
export const CLEAR_ICD9 = 'CLEAR_ICD9'

//użytkownik zalogowany
export const GET_CURRENTUSER = 'GET_CURRENTUSER'
export const SET_CURRENTUSER_LOADING = 'SET_CURRENTUSER_LOADING'
export const GET_CURRENTUSER_FAIL = 'GET_CURRENTUSER_FAIL'
export const CLEAR_CURRENTUSER= 'CLEAR_CURRENTUSER'

///reset hasła
export const POST_NEWPASS = 'POST_NEWPASS'
export const PASS_FAIL = 'PASS_FAIL'

//zmiana hasła profil
export const POST_NEWPASSWORD = 'POST_NEWPASSWORD'
export const PASSWORD_FAIL = 'PASSWORD_FAIL'














